import { NotificationManager } from "react-notifications";

const getToastMessage = (message) => {
  if (typeof message === "string") return message;
  if (message?.message) return message.message;
  if (message?.error) return message.error;
  return "Not able to connect the server. Please try again later";
};

//Toast
export const Toast = ({ type = "success", message, time = 2000 }) => {
  if (Array.isArray(message)) {
    let item;

    for (item of message) {
      NotificationManager[type](getToastMessage(item), "", time);
    }
  } else {
    NotificationManager[type](getToastMessage(message), "", time);
  }
};
